import { Component, Input, OnInit } from '@angular/core';
import { CarouselModel } from '../../models/carousel/carousel.model';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input() banners : CarouselModel[];
  constructor() { }

  ngOnInit(): void {
  }

}
